<template>
  <form-filtered-multiselect
    :value="storedTags"
    :options="tagOptions"
    :placeholder="placeholder"
    :limit-height="limitHeight"
    :hide-selected="hideSelected"
    :disabled="disabled"
    track-by="value"
    label="label"
    @input="onTagsSelected" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    limitHeight: {
      type: Boolean,
      default: false
    },
    selectedKeys: {
      default: () => {
        return []
      }
    },
    placeholder: {
      default: 'Please select Tags'
    },
    hideSelected: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: [],
      storedTags: []
    }
  },
  computed: {
    ...mapGetters('tag', ['tagOptions'])
  },
  watch: {
    selectedKeys: function (newVal) {
      this.storedTags = newVal
    }
  },
  created () {
    this.storedTags = this.selectedKeys
  },
  methods: {
    onTagsSelected (tags) {
      this.$emit('valuesSelected', tags)
    }
  }
}
</script>

<style>

</style>
